module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_photowedding-de8b889410b2f5ed1c32e80ae00f0309.webp";